import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExit = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M10 10L30 30",
		stroke: "currentColor",
		strokeWidth: 2.5,
		strokeMiterlimit: 10,
		strokeLinecap: "square",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M30 10L10 30",
		stroke: "currentColor",
		strokeWidth: 2.5,
		strokeMiterlimit: 10,
		strokeLinecap: "square",
		strokeLinejoin: "round"
	})]
});
const ForwardRef = forwardRef(SvgExit);
export default ForwardRef;
